<div class="modal-header">
  <button type="button" class="close" ng-click="ctrl.close()">×</button>
  <h4 class="modal-title">Selecione a(s) praga(s)</h4>
</div>
<div class="modal-body praga-modal">
  <div class="row">
    <div class="col-xs-12 col-sm-6 mb-sm-1">
      <ui-select ng-model="ctrl.tipo" theme="bootstrap" id="tipo" name="tipo" ng-change="ctrl.filterPragasTipo()">
        <ui-select-match allow-clear="true" placeholder="Tipo" >{{$select.selected.descricao}}</ui-select-match>
        <ui-select-choices repeat="tipo in ctrl.tiposOcorrencias | filter: $select.search">
          <span class="form-group" ng-bind-html="tipo.descricao | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>
    </div>
    <div class="col-xs-12 col-sm-6">
      <input class="m-b-sm form-control" ng-model="ctrl.filter" placeholder="Filtro..." ng-change="ctrl.filterPragasDescricao()">
    </div>
  </div>
  <div style="height:500px;overflow-x:scroll;">
    <table class="table table-hover">
      <thead>
        <tr>
          <th></th>
          <th>Praga</th>
          <th>Tipo</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="praga in ctrl.pragas" ng-class="{info: ctrl.pragaSelected(praga)}" class="pointer"
          ng-click="ctrl.toggle(praga)">
          <td><input type="checkbox" name="pragas[]" ng-checked="ctrl.pragaSelected(praga)"></td>
          <td>{{praga.descricao}}</td>
          <td>{{praga.tp_ocorrencia_to_pt_br}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="modal-footer text-right">
  <button type="button" class="btn btn-white" ng-click="ctrl.close()">Cancelar</button>
  <button type="button" class="btn btn-primary" ng-click="ctrl.save()">Selecionar</button>
</div>